
  <div class="progress-background">
    <div class="progress-bar" [style.width]="_value">
    </div>
  </div>
  